module.exports = __webpack_public_path__ + "img/brain_static.3623c953.png";